import React, { lazy } from 'react';
import HippyApiIcon from '@/assets/images/menu/icon-hippy-api.react.svg?react';
import HippyErrorIcon from '@/assets/images/menu/icon-hippy-error.react.svg?react';
import HippyEventIcon from '@/assets/images/menu/icon-hippy-event.react.svg?react';
import HippyLogIcon from '@/assets/images/menu/icon-hippy-log.react.svg?react';
import HippyPerfIcon from '@/assets/images/menu/icon-hippy-perf.react.svg?react';
import HippyPvIcon from '@/assets/images/menu/icon-hippy-pv.react.svg?react';
import HippySpeedIcon from '@/assets/images/menu/icon-hippy-speed.react.svg?react';
import HippyStaticIcon from '@/assets/images/menu/icon-hippy-static.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const hippyRoutes = (): IRouteConfig[] => [
  {
    path: '/hippy/error',
    name: 'JS错误',
    component: lazy(() => import('@/presentation/pages/hippy/error')),
    platforms: [CapitalPlatform.Hippy],
    icon: <MenuIcon icon={HippyErrorIcon} fontSize={16} />,
    sort: 100,
  },
  {
    path: '/hippy/api',
    name: 'CGI监控',
    platforms: [CapitalPlatform.Hippy],
    icon: <MenuIcon icon={HippyApiIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/hippy/api')),
    sort: 99,
  },
  {
    path: '/hippy/static',
    name: '静态资源',
    platforms: [CapitalPlatform.Hippy],
    icon: <MenuIcon icon={HippyStaticIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/hippy/static')),
  },
  {
    path: '/hippy/perf',
    name: '页面性能',
    platforms: [CapitalPlatform.Hippy],
    icon: <MenuIcon icon={HippyPerfIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/hippy/perf')),
  },
  {
    path: '/hippy/pv',
    name: '页面访问',
    platforms: [CapitalPlatform.Hippy],
    icon: <MenuIcon icon={HippyPvIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/hippy/pv')),
  },
  {
    path: '/hippy/event',
    name: '自定义事件',
    platforms: [CapitalPlatform.Hippy],
    icon: <MenuIcon icon={HippyEventIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/hippy/event')),
  },
  {
    path: '/hippy/custom',
    name: '自定义测速',
    platforms: [CapitalPlatform.Hippy],
    icon: <MenuIcon icon={HippySpeedIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/hippy/custom')),
  },
  {
    path: '/hippy/log',
    name: '日志',
    platforms: [CapitalPlatform.Hippy],
    icon: <MenuIcon icon={HippyLogIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/hippy/log')),
  },
];

export default hippyRoutes;
